import { completedSeqFlowPostfix } from '../../../../features/tracking/models/CompletedItemsStore';
import { Guid } from '../../../model/guid';
import {
  CourseCompletionStatus,
  IPersistenceTrackingClient,
  QuizStatus,
  TrackingClient,
  TrackingData,
  TrackingDataVersion,
} from './trackingClient';
import { addSequencedFlowPostfix, TrackingIdentifier } from '@ael/core-api';

export class TrackingClientTrackingIdWrapper implements TrackingClient {
  _convertToTrackingId: (itemId: Guid) => TrackingIdentifier;
  _client: IPersistenceTrackingClient;

  constructor(convertToTrackingId: (itemId: Guid) => TrackingIdentifier, client: IPersistenceTrackingClient) {
    this._convertToTrackingId = convertToTrackingId;
    this._client = client;
  }

  setCompletionStatus(status: CourseCompletionStatus): Promise<void> {
    return this._client.setCompletionStatus(status);
  }

  private convertItemIdToTrackingId = (itemId: Guid): TrackingIdentifier => {
    if (itemId.endsWith(completedSeqFlowPostfix)) {
      const itemIdWithoutPostfix = itemId.substring(0, itemId.length - completedSeqFlowPostfix.length);
      const trackingId = addSequencedFlowPostfix(this._convertToTrackingId(itemIdWithoutPostfix));

      return trackingId;
    }
    return this._convertToTrackingId(itemId);
  };

  setTrackingData({ widgetTrackingData, finishedItems }: TrackingData): Promise<void> {
    return this._client.setTrackingData({
      finishedItems: finishedItems.map(this.convertItemIdToTrackingId).toSet(),
      widgetTrackingData,
      version: TrackingDataVersion.v2,
    });
  }

  setQuizStatus(quizStatus: QuizStatus): Promise<void> {
    return this._client.setQuizStatus(quizStatus);
  }
}
